import { createAction } from 'redux-actions-helpers'
import { ContestType } from '../ProfileContestsPage/types'
import { FormDataType, TempFileItem } from './types'

export const fetchContest = createAction(
  '@@profile-contests-work/FETCH_CONTEST',
  (id: string): any => ({ id })
)

export const fetchContestSuccess = createAction(
  '@@profile-contests-work/FETCH_CONTEST_SUCCESS',
  (result: ContestType | null): any => ({ result })
)

export const fetchContestFailure = createAction(
  '@@profile-contests-work/FETCH_CONTEST_FAILURE',
  (error: string): any => ({ error })
)

export const sendWork = createAction(
  '@@profile-contests-work/SEND_WORK',
  (data: FormDataType): any => ({ data })
)

export const sendWorkSuccess = createAction(
  '@@profile-contests-work/SEND_WORK_SUCCESS'
)

export const sendWorkFailure = createAction(
  '@@profile-contests-work/SEND_WORK_FAILURE',
  (error: string): any => ({ error })
)

export const updateWork = createAction(
  '@@profile-contests-work/UPDATE_WORK',
  (work_id: string, data: FormDataType): any => ({
    work_id,
    data,
  })
)

export const updateWorkSuccess = createAction(
  '@@profile-contests-work/UPDATE_WORK_SUCCESS'
)

export const updateWorkFailure = createAction(
  '@@profile-contests-work/UPDATE_WORK_FAILURE',
  (error: string): any => ({ error })
)

export const uploadFile = createAction(
  '@@profile-contests-work/UPLOAD_FILE',
  (
    file: File,
    uploadProcess: (percent: number) => void,
    uploadedFile: (uploadedFile: TempFileItem) => void
  ): any => ({
    file,
    uploadProcess,
    uploadedFile,
  })
)

export const uploadFileSuccess = createAction(
  '@@profile-contests-work/UPLOAD_FILE_SUCCESS'
)

export const uploadFileFailure = createAction(
  '@@profile-contests-work/UPLOAD_FILE_FAILURE',
  (error: string): any => ({ error })
)

export const removeFile = createAction(
  '@@profile-contests-work/REMOVE_FILE',
  (file_id: string): any => ({ file_id })
)

export const removeFileSuccess = createAction(
  '@@profile-contests-work/REMOVE_FILE_SUCCESS',
  (file_id: string): any => ({ file_id })
)

export const removeFileFailure = createAction(
  '@@profile-contests-work/REMOVE_FILE_FAILURE',
  (error: string): any => ({ error })
)

export const removeFileFromWork = createAction(
  '@@profile-contests-work/REMOVE_FILE_FROM_WORK',
  (wid: string, file_id: string): any => ({ wid, file_id })
)

export const removeFileFromWorkSuccess = createAction(
  '@@profile-contests-work/REMOVE_FILE_FROM_WORK_SUCCESS',
  (file_id: string): any => ({ file_id })
)

export const removeFileFromWorkFailure = createAction(
  '@@profile-contests-work/REMOVE_FILE_FROM_WORK_FAILURE',
  (error: string): any => ({ error })
)

export const fetchMyWork = createAction(
  '@@profile-contests/FETCH_MY_WORK',
  (work_id: string): any => ({ work_id })
)

export const fetchMyWorkSuccess = createAction(
  '@@profile-contests/FETCH_MY_WORK_SUCCESS',
  (result: any): any => ({ result })
)

export const fetchMyWorkFailure = createAction(
  '@@profile-contests/FETCH_MY_WORK_FAILURE',
  (error: string): any => ({ error })
)

export const setUploadProgress = createAction(
  '@@profile-contests/SET_UPLOAD_PROGRESS',
  (percent: number): any => ({ percent })
)

export const destroy = createAction('@@profile-contests-work/DESTROY')
